import React, {useEffect} from 'react';
import Stack from '@mui/material/Stack';
import axios from 'axios';
import '../../../styles/PlanManager.css'
import {TreeViewBaseItem} from '@mui/x-tree-view/models';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Autocomplete from '@mui/material/Autocomplete';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {getWithExpiry, refreshToken, setWithExpiry} from "../../../globals/GlobalFunctions";
import {GlobalConstants} from "../../../globals/GlobalConstants";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';

//axios.defaults.headers.common['Authorization'] = `Bearer ${}`;

function PlanManager() {
    const [plans, setPlans] = React.useState([]);
    const [currentPlan, setCurrentPlan] = React.useState({plan_ID: "", description: "", plan_Type: "",
        vbasoftware_database: "CoastalAdminTest", vbapi_Token: null});
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [validationError, setValidationError] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [currentDB, setCurrentDB] = React.useState("CoastalAdminTest");

    const handleChange = React.useCallback((e: any) => setCurrentPlan((prev: any) => ({ ...prev, [e.target.name]: e.target.value })), []);

    const initialPlanState = {
        plan_ID: "",
        description: "",
        plan_Type: "",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: null
    }

    const handleValidationClose = () => {
        setValidationError(false);
    }

    let token = localStorage.getItem('jwt');
    //console.log('jwt', token);

    type treePlans = TreeViewBaseItem<{
        plan_ID: string;
        label: string;
    }>;

    const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
        color: theme.palette.grey[200],
        [`& .${treeItemClasses.content}`]: {
            [`& .${treeItemClasses.label}`]: {
                fontSize: '1.4vh',
                fontWeight: 500,
            },
        }}),
        );

    const getPlan = (planID : string) => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null){
            vbapi_Token = "empty";
        }
        axios
            .get(
                localStorage.getItem('baseURL') + 'plan/get/' + planID + '/' + currentDB + '/' + vbapi_Token,
                {headers: {'Authorization': `Bearer ${token}`}}
            )
            .then((response) => {
                //console.log(response);
                setCurrentPlan(response.data);
                setWithExpiry("vbapi_Token", response.data.vbapi_Token);
            })
            .catch();
    }

    function handleTreeViewSelect(event: React.SyntheticEvent, id: string | null) {
        if (id){
            getPlan(id);
        }
    }

    const onDBChange = React.useCallback((e: any, newDB: any) => setCurrentDB(newDB.id), []);

    const clearPlan = () => {
        setCurrentPlan({...initialPlanState});
    }

    useEffect(() => {
        setIsLoading(true);
        getPlanList();
        clearPlan();
        //console.log("please god", currentDB);
    }, [currentDB]);

    const getPlanList = async () => {
        refreshToken();
        var vbapi_Token = getWithExpiry('vbapi_Token');
        if(vbapi_Token == null){
            vbapi_Token = "empty";
        }
        const response =
            await axios
                .get(
                    localStorage.getItem('baseURL') + 'plan/getList/' + currentDB + '/' + vbapi_Token,
                    {headers: {'Authorization': `Bearer ${token}`}}
                );
        //console.log(response);
        setPlans(response.data);
        setWithExpiry("vbapi_Token", response.data.vbapi_Token);
        setIsLoading(false);
        //console.log("token", getWithExpiry('vbapi_Token'));
    }

    const validatePlan = () => {
        setLoading(true);
        if (!(currentPlan.plan_Type.length > 0) || !(currentPlan.plan_ID.length > 0) || !(currentPlan.description.length > 0)) {
            setLoading(false);
            setValidationText("All fields are required to save a plan.");
            setValidationError(true);
        }
        else {
            savePlan();
        }
    }

    const savePlan = async () => {
        refreshToken();
        currentPlan.vbasoftware_database = currentDB;
        currentPlan.vbapi_Token = getWithExpiry('vbapi_Token');
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'plan/put',
                    currentPlan,
                    {headers: {'Authorization': `Bearer ${token}`}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    getPlanList();
                }).catch((error) => {
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                });
        //console.log(response);
    }

    const getItemId = (item: treePlans) => item.plan_ID;

    return (
        <div>
            <Box sx={{overflowY: 'scroll', border: '2px solid #3B6BA3', background: '#3B6BA3', borderRadius: '10px'}}
                 style={{float: "right", minHeight: '25vh', maxHeight: '75vh', maxWidth: '20%', minWidth: '10%'}}>
                <div style={{marginRight: "1vh", padding: "1vh"}}><b>Plans</b></div>
                <RichTreeView items={plans} slots={{item: CustomTreeItem}} getItemId={getItemId}
                              onSelectedItemsChange={handleTreeViewSelect}/>
            </Box>

            <div className="planFormContainer">
                <div className="planFormRow">
                    <div className="planFormField">
                        <span className="planFieldLabel">Plan ID</span>
                        <TextField name="plan_ID" variant="outlined" className="planInputFull" size="small"
                                   value={currentPlan.plan_ID} onChange={handleChange}/>
                    </div>
                    <div className="planFormField">
                        <span className="planFieldLabel">Description</span>
                        <TextField name="description" variant="outlined" className="planInputFull" size="small"
                                   value={currentPlan.description} onChange={handleChange}/>
                    </div>
                    <div className="planFormField">
                        <span className="planFieldLabel">Plan Type</span>
                        <TextField name="plan_Type" variant="outlined" className="planInputFull" size="small"
                                   value={currentPlan.plan_Type} onChange={handleChange}/>
                    </div>
                </div>
            </div>

            <Dialog open={validationError} onClose={handleValidationClose}
                    aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{"Validation Error"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{validationText}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>

            {successAlert &&
                <Alert className="planAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                    <AlertTitle>Success!</AlertTitle>
                    Plan Save Successful!
                </Alert>}

            <Stack spacing={5} direction="row" className="planButtonBar">
                <Autocomplete className="dbSelect" size="small" disablePortal disableClearable
                              options={GlobalConstants.VBA_DB}
                              value={GlobalConstants.VBA_DB.find(option => option.id === currentDB) || null}
                              sx={{width: 150}} defaultValue={GlobalConstants.VBA_DB[0]}
                              renderInput={(params) => <TextField {...params}/>}
                              onChange={onDBChange}/>
                <Button variant="contained" onClick={clearPlan} size="large">Clear</Button>
                <LoadingButton className="planButtonz" variant="contained" onClick={validatePlan} size="large"
                               loading={loading} loadingPosition="start" startIcon={<SaveIcon/>}>Save</LoadingButton>
            </Stack>

            <Backdrop sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}} open={isLoading}>
                <CircularProgress color="inherit"/>
            </Backdrop>
        </div>
    );
}

export default React.memo(PlanManager);